import { createSlice } from "@reduxjs/toolkit"
import { PURGE } from "redux-persist"

const initialState = {
  user: {},
}

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    getUser: (state, action) => {
      return {
        ...state,
        user: action.payload || {},
      }
    },
    logoutSuccess() {
      return {
        user: {},
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState)
  },
})

export const { getUser, logoutSuccess } = userSlice.actions
export const selectUser = (state) => state.user
export const userReducer = userSlice.reducer
